<template>
  <div class="activity-detail"
       v-loading="loading">
    <!-- 顶部轮播 -->
    <div class="body-info"
         v-show="info.activityBanner.length">
      <el-carousel height="405px">
        <el-carousel-item v-for="(item,index) in info.activityBanner"
                          :key="index">
          <img :src="item.bannerUrl"
               width="1190"
               height="100%"
               @click="goOther(item.pcJumpUrl)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 品牌区域 -->
    <div class="body-info activities">
      <h2>{{info.brandTitle}}</h2>
    </div>
    <div class="body-info brand-list">
      <el-row :gutter="10">
        <el-col :span="6"
                v-for="(item, index) in info.brandList"
                :key="index"
                class="brand-show-info">
          <img :src="item.markPhotoPath"
               :alt="item.name"
               class="brand-img"
               @click="getgoodsByBrand(item.name)">
        </el-col>
      </el-row>
    </div>
    <!-- 分组区域 -->
    <div v-for="(groupItem, index) in info.activitySpecialArea"
         :key="groupItem.id"
         class="group">
      <div class="group-banner">
        <el-carousel height="127px">
          <el-carousel-item v-for="(item,index) in groupItem.bannerList"
                            :key="index"
                            :autoplay="false"
                            :loop="false">
            <img :data-key="item.pcSpecialAreaUrl"
                 :src="item.pcSpecialAreaUrl"
                 width="1190"
                 height="127" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="group-goodlist">
        <el-row :gutter="10">
          <el-col :span="6"
                  v-for="(item, index) in (groupItem.activitySpuVoList.length > 19 ? groupItem.activitySpuVoList.slice(0,19) : groupItem.activitySpuVoList)"
                  :key="index">
            <div class="good-info">
              <div class="good-info-img"
                   @click="goodDetail(item)">
                <img :src="(item.fileVoList && item.fileVoList.length) > 0 ? item.fileVoList[0].fileUrl : 'static/img/bitmap.png'"
                     alt=""
                     class="good-img">
              </div>
              <div class="good-detail-info">
                <div class="good-name overell">{{item.spuName}}</div>
                <div class="good-price">
                  <span class="good-info-price-activity">￥{{item.activityPrice}}</span>
                  <span v-if="item.tagPrice!==''&&item.tagPrice!==null" class="good-info-price-original">￥{{item.tagPrice}}</span>
                  <span v-else class="good-info-price-original">￥{{item.sellingPrice}}</span>
                </div>
                <div class="good-name overell">品牌：{{item.brandName}}</div>
                <div class="good-name overell">型号：{{item.model}}</div>
              </div>
            </div>
          </el-col>
          <!-- 更多 -->
          <el-col :span="6"
                  v-show="groupItem.activitySpuVoList.length > 19">
            <div class="good-info good-more">
              <div class="good-info-more-outside"
                   @click="goMore(activityDetailId, index)">
                <div class="good-info-more">
                  <div class="info-text info-ch">查看更多<i class="el-icon-caret-right"></i></div>
                  <hr>
                  <div class="info-text">TO VIEW MORE</div>
                  <i class="el-icon-search more-icon"></i>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 活动细则 -->
    <div class="body-info activity-info"
         v-show="info.activityDesc">
      <h2>活动细则说明</h2>
      <div class="product-explain"
           v-html="info.activityDesc">
        <!-- <p>1、在平台发布的<span class="black-font">线缆类促销商品</span>，客户在线询价后，下单即可享受特价优惠。</p>
        <p>2、在平台发布的<span class="black-font">桥架类促销商品</span>均已标价，所标价格为面价，客户在平台下单后，会有专属销售人员进行改价。</p>
        <p>3、桥架类商品运输费用说明：<span class="black-font">300公里内包邮；超出300公里，需另行收取运费。</span></p>
        <p>4、本次活动仅限纯产品销售范畴，<span class="black-font">工程项目（含技改技措）</span>当中的桥架、线缆类商品交易，不在本次活动范围。</p> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { openOther } from '@/utils/index'
import { purchaseInfoBuringPoint } from '@/utils/eventTracking'
export default {
  data () {
    return {
      loading: false,
      activityDetailId: '',
      info: {
        title: '',
        activityBanner: [], // 轮播图
        activityDesc: '', // 活动规则描述
        brandTitle: '',
        brandList: [],
        activitySpecialArea: [] // 活动专区分组
      }
    }
  },
  // computed: {
  //   id () {
  //     console.log(111)
  //     this.activityDetailId = this.$route.query.id
  //     this.getInfo()
  //     return this.$route.query.id
  //   }
  // },
  // watch: {
  //   id (val) {
  //     if (val) {
  //       console.log(222)
  //       this.activityDetailId = val
  //       this.getInfo()
  //     }
  //   }
  // },
  filters: {
    getBrand (arr) {
      let result = ''
      if (arr && arr.length) {
        let index = arr.findIndex((item) => {
          return item.branded === true
        })
        if (index > -1) {
          result = arr[index].productAttributeValues[0]
        }
      }
      return result
    },
    getModel (arr) {
      let result = ''
      if (arr && arr.length) {
        let index = arr.findIndex((item) => {
          return item.productAttribute === '型号'
        })
        if (index > -1) {
          result = arr[index].productAttributeValues[0]
        }
      }
      return result
    }
  },
  // components: {
  //   swiper,
  //   swiperSlide
  // },
  mounted () {
    if (this.$route.query.id !== '' && this.$route.query.id !== null && this.$route.query.id !== undefined) {
      this.activityDetailId = this.$route.query.id
      this.getInfo()
    }
    // this.getInfo()
  },
  methods: {
    // 获取活动详情
    getInfo () {
      this.loading = true
      this.$http
        .get(`/front/order/special/activity/info/pc/` + this.activityDetailId)
        .then(({ data: res }) => {
          if (res.code === 0) {
            purchaseInfoBuringPoint(this.activityDetailId)
            let info = res.data
            // 顶部banner
            this.info.activityBanner = info.activityBannerVo
              ? info.activityBannerVo.filter((item) => {
                return (
                  item.bannerUrl && item.bannerUrl !== '' && item.status === 0
                )
              })
              : []
            this.info.title = info.title
            this.info.activityDesc = info.activityDesc
            this.info.brandTitle = info.brandTitle
            this.info.brandList = info.businessBrandDetailsVo
            let activitySpecialArea =
              info.activitySpecialAreaVo && info.activitySpecialAreaVo.length
                ? info.activitySpecialAreaVo.map((group) => {
                  group.activitySpuVoList.map(item1 => {
                    let skuId = item1.skuId
                    item1.activitySKUList.forEach(item2 => {
                      if (skuId === item2.skuId) {
                        item1.model = item2.model
                      }
                    })
                  })
                  return {
                    ...group,
                    bannerList:
                        group.activitySpecialAreaCarouselVo &&
                        group.activitySpecialAreaCarouselVo.length
                          ? group.activitySpecialAreaCarouselVo.filter(
                            (item) => {
                              return item.pcSpecialAreaUrl !== ''
                            }
                          )
                          : []
                  }
                })
                : []
            this.info.activitySpecialArea = activitySpecialArea
            // console.log(this.info.activitySpecialArea)
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 进入商品详情页
    goodDetail (good) {
      if (good) {
        openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId || ''}`)
      }
    },
    goMore (activityId, activityIndex) {
      let groupId = this.info.activitySpecialArea[activityIndex].specialAreaCarouselId
      this.$router.push({
        name: 'actuvutyGoodList',
        query: { activityId: activityId, groupId: groupId }
      })
    },
    goOther (url) {
      if (url) {
        openOther(url, true)
      }
    },
    handleClick (src) {
      window.open(src)
    },
    getMore (url) {
      window.open(url)
    },
    getgoodsByBrand (name) {
      if (name === '江苏天诚') {
      } else {
        this.$router.push({ name: 'goodsList', query: { brandName: name } })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.activity-detail {
  width: 1190px;
  margin: 0 auto;
  .body-info {
    margin-bottom: 20px;
    width: 100%;
    // padding: 30px 0px;
    // background-color: #fff;
    word-wrap: break-word;
    word-break: break-all;
    /deep/ .el-carousel .el-carousel__container {
      height: 405px !important;
    }
    // img{
    //   width:100%;
    // }
  }
  .activities {
    padding: 0px;
    color: #2378d5;
    margin-bottom: 31px;
  }
  .brand-list {
    background: #fff;
    .brand-show-info {
      margin: 5px auto;
      text-align: center;
      .brand-img {
        width: 140px;
        height: 90px;
      }
    }
  }
  .group {
    margin: 20px 0;
    .group-banner {
      height: 127px;
      width: 100%;
      margin-bottom: 20px;
    }
    .group-goodlist {
      .good-info {
        background: #fff;
        // width: 280px;
        height: 300px;
        margin-top: 5px;
        .good-info-img {
          // width: 240px;
          height: 180px;
          text-align: center;
          cursor: pointer;
          .good-img {
            width: 62%;
            height: 180px;
            border: none;
          }
        }
        .good-detail-info {
          border-top: 1px #eee solid;
          font-size: 12px;
          line-height: 26px;
          padding: 10px;
          .good-price {
            font-size: 18px;
            color: #e33135;
            letter-spacing: 0.2px;
            font-weight: bold;
            .good-info-price-original {
              color: #ccc;
              font-size: 12px;
              text-decoration: line-through;
            }
          }
        }
      }
      .good-more {
        padding: 30px;
        .good-info-more-outside {
          position: relative;
          border-top-right-radius: 50%;
          height: 100%;
          width: 100%;
          padding: 6px;
          &:before {
            content: "";
            position: absolute;
            left: 50%;
            top: 0;
            bottom: auto;
            right: auto;
            height: 50%;
            width: 50%;
            border-top-right-radius: 100%;
            border-top: 6px solid #1d65a8;
            border-right: 6px solid #1d65a8;
          }
        }
        .good-info-more {
          background: #fff;
          padding: 30px;
          cursor: pointer;
          widows: 100%;
          height: 100%;
          border-radius: 140px;
          border: 6px solid #ddd;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          .info-ch {
            font-size: 20px;
          }
          .info-text {
            line-height: 30px;
          }
          .more-icon {
            font-size: 20px;
          }
        }
      }
    }
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}

.body-info h2 {
  font-size: 24px;
  color: #262626;
  margin-top: 0px;
  text-align: center;
}

.product-banner {
  margin: 20px 0;
  width: 100%;
  word-wrap: break-word;
  word-break: break-all;
  margin-bottom: 0px;
  margin-top: 34px;
}
.product-banner img {
  width: 100%;
}

.activities h2 {
  color: #2378d5;
  font-size: 46px;
}
.brand-list {
  padding-top: 0px;
}
.left-img {
  width: 270px;
  height: 1123px;
  float: left;
}
.left-img img {
  width: 100%;
  height: 100%;
}
.right-img {
  width: 920px;
  height: 1123px;
  float: left;
  // background:pink;
}
.list-img {
  width: 290px;
  margin-left: 16px;
  margin-bottom: 7px;
  height: 275px;
  background: #fff;
  float: left;
}
.list-img dt {
  height: 180px;
  cursor: pointer;
}
.list-img dt img {
  height: 180px;
}
.list-img dd {
  font-size: 12px;
  margin: 0px 0px;
  padding: 10px;
  height: 80px;
  line-height: 26px;
  border-top: 1px #eee solid;
}
.list-nobottom {
  margin-bottom: 0;
}
.body-list {
  padding-top: 0px;
  margin-top: 25px;
  margin-bottom: 34px;
}
.body-list::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
ul li {
  list-style: none;
}
.product-explain {
  padding-left: 150px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.product-explain h3 {
  font-size: 20px;
}
.product-explain p {
  margin-top: 5px;
  font-size: 16px;
}
.body-brand {
  width: 100%;
  height: 250px;
  background: #fff;
}
.body-brand img {
  width: 130px;
  height: 80px;
  margin-left: 15px;
  margin-top: 22px;
  cursor: pointer;
}
.body-brand .no-cursor {
  cursor: default;
}
.body-brand .margin-large {
  margin-left: 25px;
}
.getMore {
  cursor: pointer;
}
.activity-info {
  background-color: #fff;
  border: 3px solid #e7e7e7;
}
.activity-info h2 {
  color: #8e8e8e;
  font-size: 38px;
  margin-bottom: 25px;
}
.activity-info p {
  margin-top: 15px;
}
.black-font {
  color: #252525;
  font-weight: 800;
}
</style>
<style>
div.activityBanner .el-carousel .el-carousel__container {
  height: 405px !important;
}
</style>
